import React from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';
import { InvoiceCopyService } from 'frilans-finans';

export class InvoiceCopy extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      ocrNumber: '',
      companyId: '',
      failed: false
    };
  }

  handleInvoiceNumberChange = (event) => {
    this.setState({ocrNumber: event.target.value});
  }

  handleCompanyIdChange = (event) => {
    this.setState({companyId: event.target.value});
  }

  getPdf = () => {
    this.setState({failed: false});
    InvoiceCopyService.get(this.state.ocrNumber, this.state.companyId).then((response) => {
      window.open(response.url);
    }, () => {
      this.setState({failed: true});
    });
  }

  render () {
    return (
      <div className='invoice-copy'>
        <header><Translate content='INVOICE_COPY_DOWNLOAD'/></header>
        <section className='logo'>
          <img src={require('images/logos/logo-blue-new.png')} alt='Frilans Finans-logotyp' />
        </section>
        <section className='about-invoice-copy-page'>
          <p><Translate content='INVOICE_COPY_ABOUT_PAGE'/></p>
        </section>
        <section>
          <input
            type='text'
            placeholder={proxyCounterpart('INVOICE_COPY_ENTER_OCR_NUMBER')}
            name='ocrNumber'
            value={this.state.ocrNumber}
            onChange={this.handleInvoiceNumberChange}
          />
          <input
            type='text'
            placeholder={proxyCounterpart('INVOICE_COPY_ENTER_COMPANY_ID')}
            name='companyId'
            value={this.state.companyId}
            onChange={this.handleCompanyIdChange}
          />
          {this.state.failed &&
            <p className='error'><Translate content='INVOICE_COPY_COULD_NOT_FIND_INVOICE'/></p>
          }
          <a className='btn' onClick={this.getPdf}><Translate content='INVOICE_COPY_SUBMIT'/></a>
        </section>
      </div>
    );
  }
}
export default InvoiceCopy;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-copy/invoice-copy.js
 **/